function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 3.37622C24 1.72045 22.6558 0.376221 21 0.376221H3C1.34423 0.376221 0 1.72045 0 3.37622V21.3762C0 23.032 1.34423 24.3762 3 24.3762H21C22.6558 24.3762 24 23.032 24 21.3762V3.37622Z",
  fill: "#FAFAFA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.87948 8.75073H2.85948V20.8427H6.87948V8.75073Z",
  fill: "#135FA5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.899 2.92065C3.52364 2.92065 2.625 3.82487 2.625 5.01001C2.625 6.17026 3.49631 7.09942 4.8458 7.09942H4.87177C6.27347 7.09942 7.14595 6.17026 7.14595 5.01001C7.11994 3.82487 6.27356 2.92065 4.899 2.92065Z",
  fill: "#135FA5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7468 8.46655C14.6144 8.46655 13.6593 9.63922 13.1245 10.4629V8.7509H9.1055C9.1588 9.88513 9.1055 20.8428 9.1055 20.8428H13.1244V14.0898C13.1244 13.7284 13.1504 13.367 13.2569 13.1087C13.547 12.3868 14.2087 11.6391 15.3191 11.6391C16.7728 11.6391 17.3552 12.7483 17.3552 14.3731V20.8428H21.3743V13.9086C21.3743 10.1944 19.3912 8.46655 16.7468 8.46655Z",
  fill: "#135FA5"
});

var SvgLinkedInIcon = function SvgLinkedInIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedInIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedIn_icon.bfb356ee.svg";
export { ForwardRef as ReactComponent };